// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"592":"aea642aa","664":"28c37033"}[chunkId] + ".chunk.js";
};